<template>
	<!-- Team start -->
	<section class="section" id="services">
		<div class="container">
			<div class="row justify-content-center mb-5">
				<div class="col-lg-12">
					<h4 class="text-uppercase mb-3 pb-1">인스타그램 마케팅</h4>
				</div>
				<div class="col-lg-12"></div>
				<div class="col-lg-12 mt-5">
					<div class="card rounded border-0 shadow overflow-hidden">
						<ul class="nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item" role="presentation">
								<button class="nav-link active" id="apply-tab" data-bs-toggle="tab" data-bs-target="#apply" type="button" role="tab" aria-controls="apply" aria-selected="false" ref="apply">신청하기</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link " id="notice-tab" data-bs-toggle="tab" data-bs-target="#notice" type="button" role="tab" aria-controls="notice" aria-selected="true">서비스 안내</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="cancel-tab" data-bs-toggle="tab" data-bs-target="#cancel" type="button" role="tab" aria-controls="cancel" aria-selected="false">취소 및 환불</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="qna-tab" data-bs-toggle="tab" data-bs-target="#qna" type="button" role="tab" aria-controls="qna" aria-selected="false">자주 묻는 질문</button>
							</li>
							<li class="nav-item" role="presentation">
								<button class="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="false">이용후기</button>
							</li>
						</ul>
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade px-4 py-5 show active" id="apply" role="tabpanel" aria-labelledby="apply-tab">
								<h4 class="text-uppercase mb-3 pb-1 text-center">신청하기</h4>
								<div class="tab-content" id="pricingpills-tabContent">
									<div class="tab-pane fade show active" id="pills-monthly" role="tabpanel" aria-labelledby="pills-monthly-tab">
										<div class="row">
											<div class="col-lg-4">
												<div class="card plan-card mt-4 rounded text-center border-0 shadow overflow-hidden">
													<div class="card-body px-4 py-5">
														<!-- <div class="icon-mono avatar-md bg-soft-primary text-primary rounded mx-auto mb-5"><i class="icon-lg" data-feather="circle"></i></div> -->
														<div class="icon-mono avatar-md bg-soft-primary rounded mx-auto mb-5 p-3">
															<img src="../../../images/pricing/1.png" alt="" class="img-fluid d-block mx-auto" />
														</div>
														<h4 class="text-uppercase mb-4 pb-1">Basic</h4>
														<p class="text-muted"><span class="fw-bold">인스타그램 & 자사몰 연동</span></p>
														<p class="text-muted font-size-14 mb-1">인스타그램 샵승인</p>
														<p class="text-muted font-size-14 mb-1">인스타그램 쇼핑태그 활성화</p>
														<p class="text-muted font-size-14 mb-1">쇼핑태그 적용방법 메뉴얼 제공</p>
														<p class="text-dark font-size-16 font-weight-semibold mb-4">132,000원</p>
														<button @click="tosspay('basic')" class="btn btn-soft-primary">구매하기</button>
													</div>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="card plan-card mt-4 rounded text-center border-0 shadow overflow-hidden">
													<div class="card-body px-4 py-5">
														<!-- <div class="icon-mono avatar-md bg-soft-primary text-primary rounded mx-auto mb-5"><i class="icon-lg" data-feather="square"></i></div> -->
														<div class="icon-mono avatar-md bg-soft-primary rounded mx-auto mb-5 p-3">
															<img src="../../../images/pricing/2.png" alt="" class="img-fluid d-block mx-auto" />
														</div>
														<h4 class="text-uppercase mb-4 pb-1">Standard</h4>
														<p class="text-muted"><span class="fw-bold">인스타그램 & 자사몰 (상품 자동등록) 연동</span></p>
														<p class="text-muted font-size-14 mb-1">인스타그램 샵승인</p>
														<p class="text-muted font-size-14 mb-1">인스타그램 쇼핑태그 활성화</p>
														<p class="text-muted font-size-14 mb-1">쇼핑태그 적용방법 메뉴얼 제공</p>
														<p class="text-dark font-size-16 font-weight-semibold mb-4">187,000원</p>
														<button @click="tosspay('standard')" class="btn btn-soft-primary">구매하기</button>
													</div>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="card plan-card mt-4 rounded text-center border-0 shadow overflow-hidden">
													<div class="card-body px-4 py-5">
														<span class="badge badge-primary pricing-badge shadow-lg">Most Popular</span>
														<!-- <div class="icon-mono avatar-md bg-soft-primary text-primary rounded mx-auto mb-5"><i class="icon-lg" data-feather="triangle"></i></div> -->
														<div class="icon-mono avatar-md bg-soft-primary rounded mx-auto mb-5 p-3">
															<img src="../../../images/pricing/3.png" alt="" class="img-fluid d-block mx-auto" />
														</div>
														<h4 class="text-uppercase mb-4 pb-1">Premium</h4>
														<p class="text-muted"><span class="fw-bold">인스타그램 & 스마트스토어 연동</span></p>
														<p class="text-muted font-size-14 mb-1">인스타그램 샵승인</p>
														<p class="text-muted font-size-14 mb-1">인스타그램 쇼핑태그 활성화</p>
														<p class="text-muted font-size-14 mb-1">쇼핑태그 적용방법 메뉴얼 제공</p>
														<p class="text-dark font-size-16 font-weight-semibold mb-4">198,000원</p>
														<button @click="tosspay('premium')" class="btn btn-soft-primary">구매하기</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- end monthly tab pane -->
								</div>
								<div class="col-lg-12">
									<div class="card  mt-4 rounded  border-0 shadow overflow-hidden">
										<div class="card-body">
											<ul>
												<li>결제 후 신청서를 작성해주세요.</li>
											</ul>
										</div>
									</div>
								</div>

								<div class="row align-items-center mt-5 mx-auto">
									<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSenWpSaKwLLBbSUhDhQ8_cXGRfSIxhzhnTSOjaXHWbe5wVGBw/viewform?embedded=true" width="640" height="3292" frameborder="0" marginheight="0" marginwidth="0">로드 중…</iframe>
								</div>
							</div>
							<div class="tab-pane fade  px-4 py-5 " style="text-align: center;" id="notice" role="tabpanel" aria-labelledby="notice-tab">
								<img src="/images/insta/006.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/007.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/001.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/002.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/003.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/004.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/005.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/008.png" class="img-fluid mt-2" alt="Responsive image" />
								<img src="/images/insta/009.png" class="img-fluid mt-2" alt="Responsive image" />
								<iframe
									class="mt-2 youtube-iframe"
									src="https://www.youtube.com/embed/45r1J6XcZbs"
									title="YouTube video player"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									allowfullscreen
								></iframe>
								<img src="/images/kmongreview.png" class="img-fluid mt-2" alt="Responsive image" style="width: 860px;border:1px solid aqua;" />
							</div>

							<div class="tab-pane fade px-4 py-5" id="cancel" role="tabpanel" aria-labelledby="cancel-tab">
								<h4 class="text-uppercase mb-3 pb-1 text-center">취소 및 환불</h4>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">01. 작업 시작 전 100% 환불 가능합니다. 작업이 시작되면 환불이 불가능합니다.</li>
									<li class="list-group-item">02. 작업 시작 후에도 인스타그램 SHOP 연동이 안되었을 경우 100% 환불 해드립니다.</li>
									<li class="list-group-item">(단, 의뢰인의 과실이나 단순 변심, 광고 매체 규제 등으로 인한 불이익은 환불이 불가)</li>
								</ul>
							</div>
							<div class="tab-pane fade px-4 py-5" id="qna" role="tabpanel" aria-labelledby="qna-tab">
								<h4 class="text-uppercase mb-3 pb-1 text-center">자주 묻는 질문</h4>
								<div class="accordion" id="accordionExample">
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingOne">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
												<strong>Q.스마트스토어와 인스타그램 연동이 가능한가요?</strong>
											</button>
										</h2>
										<div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												네, 가능합니다.(2023년 7월 20일 현재)
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingTwo">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												<strong>Q.자사몰 또는 독립몰도 가능한가요?</strong>
											</button>
										</h2>
										<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												네, 가능합니다.(2023년 7월 20일 현재)
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												<strong>Q.승인에 필요한 기간은 어느정도인가요?</strong>
											</button>
										</h2>
										<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												계정 상태에 따라 다릅니다. 짧게는 2~3일에서 길게는 40일정도 소요됩니다.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
												<strong>Q.준비과정에 필요한 것들은 무엇이 있나요?</strong>
											</button>
										</h2>
										<div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												개인 도메인은 필수로 필요합니다.(스마트스토어 포함) 그 외의 사항은 [신청하기] 탭에서 결제완료 후 신청서를 작성해주시면 됩니다.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
												<strong>Q.100% 승인 가능한가요?</strong>
											</button>
										</h2>
										<div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												계정 상태 또는 알고리즘 변동 상황에 따라 승인이 가능하지 않을 수 있습니다. 승인이 안 될시에는 100% 환불해드립니다.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
												<strong>Q.승인 후 추후 비승인 상태로 변경될 수 있나요?</strong>
											</button>
										</h2>
										<div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												승인 후 계정 관리에 따라 비승인 상태로 변경될 수 있습니다. 비승인 상태로 변경 시에는 무상으로 재승인을 받아드리지 못하는 점 양해부탁드립니다. (재승인을 원하실 경우 다시 서비스 구매 요청을 주셔야 하며, 재승인이 불가능하실 수도
												있습니다.)
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
												<strong>Q.모든 제품이 쇼핑태그 승인이 가능한가요?</strong>
											</button>
										</h2>
										<div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												페이스북 & 인스타그램 정책에 어긋나지 않는 제품은 모두 가능합니다.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
												<strong>Q.제품태그 방법을 알려주시나요?</strong>
											</button>
										</h2>
										<div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
											<div class="accordion-body">
												제품태그를 위한 메뉴얼을 전달드립니다. 설명이 어려울시 채팅을 통해 끝까지 제품태그를 할 수 있도록 도와드립니다.
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-pane fade px-4 py-5" id="review" role="tabpanel" aria-labelledby="review-tab">
								<h4 class="text-uppercase mb-3 pb-1 text-center">이용후기</h4>
								<div class="alert alert-warning" role="alert">
									<a href="https://cafe.naver.com/oliviewlabs" target="_blank">마이파랑 커뮤니티(네이버카페) 에 후기 작성 시 계정상태에 따른 SHOP 재연동 1회 무료 서비스를 제공해드립니다. </a>
								</div>

								<div class="row">
									<div class="col-lg-3 text-center mt-3"></div>
									<div class="col-lg-6 text-center mt-3">
										<a href="https://kmong.com/gig/391232" target="_blank" class="btn btn-lg rounded-pill" style="background-color: #FCE137;width: 350px; ">크몽 최근리뷰</a>
									</div>
									<!-- <div class="col-lg-5 text-center mt-3">
										<a href="https://cafe.naver.com/oliviewlabs?iframe_url=/ArticleList.nhn%3Fsearch.clubid=30008802%26search.menuid=79" target="_blank" class="btn btn-lg rounded-pill" style="background-color: #3DD063;width: 350px; "
											>네이버카페 최근리뷰</a
										>
									</div> -->
									<div class="col-lg-3 text-center mt-3"></div>
									<img src="/images/kmongreview.png" class="img-fluid mx-auto mt-3" alt="Responsive image" style="width: 860px;border:1px solid aqua;" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12">
					<div class="card rounded border-0 shadow overflow-hidden">
						<div class="tab-pane fade show active  px-4 py-5" id="common" role="tabpanel" aria-labelledby="common-tab">
							<h4 class="text-uppercase mb-3 pb-1 ">더 궁금한 것이 있습니다.</h4>
							<ul>
								<li class="text-muted mb-2">네이버톡톡 또는 채널톡으로 문의해주세요.</li>
								<li class="text-muted mb-2">문의 가능 시간 : 평일 11:00~17:00</li>
							</ul>
						</div>
					</div>
				</div>

				<!-- <center style="margin-top:20px;"><iframe width="800" height="600" src="https://www.youtube.com/embed/chKcte7A1P8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></center> -->
			</div>
		</div>
		<!-- end container -->
	</section>
</template>

<script>
export default {
	data() {
		return {
			// local: 'http://localhost:8080'
			local: window.location.origin
		};
	},
	mounted() {
		if (window.location.href.includes("?")) {
			let uri = window.location.href.split("?");
			if (uri.length > 0) {
				let vars = uri[1].split("&");
				if (vars[0] == "tab=apply") {
					document.getElementById("apply-tab").click();
					if (vars.length == 2 && vars[1] == "scroll=800") {
						window.scrollTo(0, 800);
					}
				}
			}
		}
	},
	methods: {
		getOrderId: function() {
			return Math.random()
				.toString(36)
				.substring(2);
		},
		tosspay: function(type) {
			let amount = 0;
			let orderName = "마이파랑 인스타 ";
			switch (type) {
				case "basic":
					amount = 132000;
					orderName += "BASIC";
					break;

				case "standard":
					amount = 187000;
					orderName += "STANDARD";
					break;

				case "premium":
					amount = 198000;
					orderName += "PREMIUM";
					break;
			}

			// const clientKey = 'test_ck_qLlDJaYngroZWMegY4NVezGdRpXx'
			const clientKey = "live_ck_d26DlbXAaV0Yl5gLDY1rqY50Q9RB";
			let orderId = this.getOrderId();

			// customerKey 의 경우 카드등록 고객의 고유ID이며, 고객사에서 생성하시면 됩니다.
			let tossPayments = TossPayments(clientKey);
			tossPayments
				.requestPayment("카드", {
					// 결제 수단 파라미터
					// 결제 정보 파라미터
					amount: amount,
					orderId: orderId,
					orderName: orderName,
					customerName: type,
					successUrl: this.local + "/pay/ts1",
					failUrl: this.local + "/pay/ts2"
				})
				.catch(function(error) {
					if (error.code === "USER_CANCEL") {
						// 결제 고객이 결제창을 닫았을 때 에러 처리
						// swal("결제승인에 실패했습니다.", {icon: "info"})
					} else if (error.code === "INVALID_CARD_COMPANY") {
						swal("유효하지 않은 카드 코드입니다.", { icon: "info" });
						// 유효하지 않은 카드 코드에 대한 에러 처리
					}
				});
		}
	}
};
</script>
<style>
#table-container th,
#table-container td {
	white-space: nowrap;
	text-align: center;
}

#table-container td {
	border-bottom-color: #dee2e6;
}
#table-container th {
	border-bottom-color: #000000;
}

#table-container th:nth-child(3),
#table-container td:nth-child(3) {
	border-right-color: #dee2e6;
	border-right-width: 1px;
}
div.dataTables_wrapper {
	width: 1068px;
}

#searchedTitles {
	z-index: 10;
}

.rank-container {
	display: flex;
}
.rank-item-add:nth-child(1) {
	flex-grow: 1;
	margin-right: 10px;
}
.rank-item-add:nth-child(2) {
	flex-shrink: 0;
	width: 70px;
}

.rank-item-search:nth-child(1) {
	flex-shrink: 0;
	width: 40px;
}
.rank-item-search:nth-child(2) {
	flex-grow: 1;
}

.rank-item:nth-child(1) {
	flex-grow: 1;
	margin-right: 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.rank-item:nth-child(2) {
	flex-shrink: 0;
	width: 70px;
	margin-right: 10px;
}
.rank-item:nth-child(3) {
	flex-shrink: 0;
	width: 70px;
}

.rank-reverse-container {
	display: flex;
	flex-direction: row-reverse;
}

.rank-reverse-item:nth-child(1) {
	max-width: 170px;
}
.rank-reverse-item:nth-child(2) {
	flex-grow: 1;
	margin-right: 10px;
	padding: 0.5rem 0.5rem 0.5rem 18px;
	margin-bottom: 0;
	cursor: pointer;
}

.rank-keyword:nth-child(1) {
	flex-grow: 1;
	height: 96px;
	margin-right: 10px;
}
.rank-keyword:nth-child(2) {
	flex-shrink: 0;
	height: 96px;
	width: 70px;
}

#table-container {
	display: flex;
	flex-wrap: nowrap;
	justify-content: flex-start;
	width: 100%;
}

#table-container th,
#table-container td {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 80px;
	max-width: 100%;
}

#table-container th:nth-child(1),
#table-container td:nth-child(1) {
	min-width: 35px;
	max-width: 35px;
}
#table-container th:nth-child(2),
#table-container td:nth-child(2) {
	min-width: 50px;
	max-width: 200px;
	text-align: left;
}
#table-container th:nth-child(3),
#table-container td:nth-child(3) {
	min-width: 50px;
	max-width: 100px;
	text-align: center;
}

.cursor-pointer {
	cursor: pointer;
}

.pf {
	width: 20px;
	height: 20px;
}
.pc4-pass {
	background-color: #e2efde;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-fail {
	background-color: #ec7b7b;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-empty {
	background-color: #eeeeee;
}
.pc4-pc4 {
	background-color: #eff1fc;
}
.pc4-title {
	font-weight: bold;
}
.step {
	width: 100%;
	border: 1px solid #000000;
	image-rendering: -webkit-optimize-contrast;
	transform: translateZ(0);
	backface-visibility: hidden;
	margin-bottom: 0.5rem !important;
}
.width100 {
	width: 100%;
}
.font14 {
	font-size: 14px;
}

.nav-item .nav-link.active {
	padding: 0.5rem 1rem;
}

.nav-item .nav-link {
	display: block;
	padding: 0.5rem 1rem 0.44rem;
	color: #0d6efd;
	text-decoration: none;
	background-color: #fff;
}

.jcc-df {
	justify-content: center;
	display: flex;
}

.table .search-count {
	text-align: right;
	padding-right: 15px;
}
.rankgap {
	margin: 3px 0 0 5px;
	font-size: 12px;
	min-width: 20px;
}

.fixed-top10 {
	position: fixed;
	top: 50;
	right: 0;
	left: 0;
}
#section1 {
	padding-top: 50px;
	height: 500px;
	color: #fff;
	background-color: #1e88e5;
}
#section2 {
	padding-top: 50px;
	height: 500px;
	color: #fff;
	background-color: #673ab7;
}
#section3 {
	padding-top: 50px;
	height: 500px;
	color: #fff;
	background-color: #ff9800;
}
#section41 {
	padding-top: 50px;
	height: 500px;
	color: #fff;
	background-color: #00bcd4;
}
#section42 {
	padding-top: 50px;
	height: 500px;
	color: #fff;
	background-color: #009688;
}

.youtube-iframe {
	position: relative;
	width: 100%;
	max-width: 860px;
	height: 480px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Insta.vue